import { useCallback } from 'react';
import { useUserStore } from 'src/store/user';

// Mirrors loger-backend/utils/vendor-permissions.js. The backend enforces all
// of this; the frontend only uses it to hide what a staff login can't use.
export const LEVELS = ['none', 'view', 'manage'];

// Which permission module a dashboard page belongs to (null = anyone).
const PAGE_MODULES = [
  [/^\/dashboard\/groups\/team/, 'owner'], // owner-only: no staff has this
  [/^\/dashboard\/(groups|manage)\/reservations/, 'reservations'],
  [/^\/dashboard\/manage\/inbox/, 'inbox'],
  [/^\/dashboard\/manage\/rate-and-availability/, 'rates'],
  [/^\/dashboard\/manage\/property/, 'property'],
  [/^\/dashboard\/manage\/(promotions|bank-offers)/, 'promotions'],
  [/^\/dashboard\/(groups|manage)\/reviews/, 'reviews'],
  [/^\/dashboard\/(groups|manage)\/finance/, 'finance'],
  [/^\/dashboard\/(groups\/(analytics|sales-statistics)|manage\/analytics)/, 'analytics']
];

export const moduleForPath = pathname =>
  PAGE_MODULES.find(([re]) => re.test(pathname))?.[1] ?? null;

export function useVendorAccess() {
  const user = useUserStore(state => state.user);
  const access = user?.vendorAccess;
  // no vendorAccess = an owner on a backend without team support
  const isOwner = access
    ? access.role === 'owner'
    : user?.usertype !== 'vendorStaff';

  const can = useCallback(
    (module, level = 'view') =>
      isOwner ||
      !module ||
      LEVELS.indexOf(access?.permissions?.[module] ?? 'none') >=
        LEVELS.indexOf(level),
    [isOwner, access]
  );

  const hasProperty = useCallback(
    propertyId =>
      isOwner ||
      !propertyId ||
      access?.allProperties ||
      (access?.properties ?? []).includes(propertyId),
    [isOwner, access]
  );

  return { isOwner, isStaff: !isOwner, access, can, hasProperty };
}
